
export default {
  props: {
    community: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      expertsCount: 0,
      companysCount: 0,
      usersCount: 0,
    }
  },
  async fetch() {
    await this.fetchExperts()
  },
  methods: {
    isActiveLinkExperts(url) {
      return this.$route.path === `/community/${url}/experts`
    },
    isActiveLinkCompanys(url) {
      return this.$route.path === `/community/${url}/experts/companys`
    },
    isActiveLinkUsers(url) {
      return this.$route.path === `/community/${url}/experts/users`
    },
    async fetchExperts() {
      const streamsIds = this.community.streams?.map((stream) => stream._id)
      const { expertsCount, companysCount, usersCount } =
        await this.$axios.$get('experts/streams/count', {
          params: {
            streams: streamsIds,
          },
        })
      this.expertsCount = expertsCount
      this.companysCount = companysCount
      this.usersCount = usersCount
    },
  },
}
